// extracted by mini-css-extract-plugin
export var aboveInput = "_km-0";
export var actionButton = "_km-5";
export var actionButtonContainer = "_km-1";
export var actionIcon = "_km-6";
export var aiInfoContainer = "_km-2";
export var attachmentWrapper = "_km-7";
export var bold = "_km-3";
export var checkIcon = "_km-8";
export var clickingRecipientBar = "_km-11";
export var commentThreadSwitch = "_km-a";
export var draftImage = "_km-b";
export var draftImageContainer = "_km-c";
export var draftImages = "_km-e";
export var editButton = "_km-g";
export var editor = "_km-f";
export var editorContainer = "_km-y";
export var editorErrorTooltipWrapper = "_km-9";
export var headerDivider = "_km-h";
export var icon = "_km-i";
export var info = "_km-j";
export var internal = "_km-n";
export var internalDivider = "_km-k";
export var internalMessage = "_km-l";
export var messageInputCard = "_km-m";
export var messageInputForm = "_km-o";
export var messageInputFormInternal = "_km-p";
export var options = "_km-q";
export var publicMessageCustomer = "_km-s";
export var publicMessageMerchant = "_km-r";
export var removeImageButton = "_km-d";
export var replyButtons = "_km-t";
export var showSignatureButton = "_km-u";
export var spinner = "_km-v";
export var verticalButtonDivider = "_km-4";
export var visibilitySelector = "_km-w";
export var warning = "_km-x";
export var wrappingText = "_km-z";
export var writingInternalNoteTopBorder = "_km-10";